import CardAController from "./CardAController";

export default CardAController;
